export const radius = {
    none: "0",
    sm: "6px",
    md: "10px",
    lg: "14px",
    xl: "20px",
    pill: "999px",
} as const;

export type RadiusKey = keyof typeof radius;
